import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledComponents";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";

const CustomerCard = ({ customer, onEdit, onDelete }) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <BusinessIcon color="primary" />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" fontWeight="bold" noWrap>
              {customer.businessName}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ID: {customer.id.substring(0, 8)}...
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1.2} sx={{ flexGrow: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <PersonIcon fontSize="small" color="action" />
            <Typography variant="body2" noWrap>
              {customer.contactName}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <PhoneIcon fontSize="small" color="action" />
            <Typography variant="body2">{customer.contactNumber}</Typography>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <EmailIcon fontSize="small" color="action" />
            <Typography variant="body2" noWrap sx={{ fontStyle: "italic" }}>
              {customer.email}
            </Typography>
          </Stack>
        </Stack>

        <Stack direction="row" justifyContent="flex-end" spacing={0.5} mt={2}>
          <Tooltip title="Edit Customer">
            <IconButton size="small" onClick={onEdit} color="secondary">
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton size="small" onClick={onDelete} color="error">
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default CustomerCard;
